import classNames from "classnames";

import styles from "../MatchControl.module.scss";

import AdjustButton from "./AdjustButton";

type TimeAdjustButtonsProps = {
	onAdd: (amount: number) => void;
	onSubtract: (amount: number) => void;
	isCompact?: boolean;
};

const getLabel = (amount: number, add: boolean) => `${add ? "+" : "-"}${amount}s`;

const TimeAdjustButtons = ({ onAdd, onSubtract, isCompact = false }: TimeAdjustButtonsProps) => (
	<div className={styles.TimeInBodyWrapper}>
		<div className={classNames(styles.TimeInItemWrapper, styles.ActionsWrapper)}>
			<AdjustButton isCompact={isCompact} onClick={() => onSubtract(1)}>
				{getLabel(1, false)}
			</AdjustButton>
			<AdjustButton isCompact={isCompact} onClick={() => onAdd(1)}>
				{getLabel(1, true)}
			</AdjustButton>
		</div>

		<div className={classNames(styles.TimeInItemWrapper, styles.ActionsWrapper)}>
			<AdjustButton isCompact={isCompact} onClick={() => onSubtract(5)}>
				{getLabel(5, false)}
			</AdjustButton>
			<AdjustButton isCompact={isCompact} onClick={() => onAdd(5)}>
				{getLabel(5, true)}
			</AdjustButton>
		</div>
	</div>
);

export default TimeAdjustButtons;
